import classNames from "classnames";
import { SyntheticEvent, useCallback, useState } from "react";
import { SearchIcon } from "../../../../core/components/icons/SearchIcon.component";
import { Button } from "../../../../core/ui";
import { CoastMediaTabConfig } from "./CoastMedia.util";

interface CoastMediaNavigationProps {
  setActiveTab: (idx: number) => void;
  onSearch: (query: string) => void;
  tabs: CoastMediaTabConfig[];
  activeTabIdx: number;
}

export const CoastMediaNavigation = ({ onSearch, setActiveTab, tabs, activeTabIdx }: CoastMediaNavigationProps) => {
  const [searchQuery, setSearchQuery] = useState("");

  const onChange = useCallback((e: SyntheticEvent<HTMLInputElement>) => {
    setSearchQuery(e.currentTarget.value);
  }, []);

  const onSubmit = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      if (searchQuery) {
        onSearch(searchQuery);
      }
    },
    [onSearch, searchQuery],
  );

  return (
    <div className="component-coast-media-navigation">
      <form onSubmit={onSubmit}>
        <input type="text" value={searchQuery} onChange={onChange} placeholder="Search videos..." />
        <Button click={onSubmit} type="submit">
          <SearchIcon />
        </Button>
      </form>

      <div className="tab-headers-container">
        {tabs.map((tab, idx) => (
          <div
            className={classNames("coast-media-tab-header", {
              active: activeTabIdx === idx,
            })}
            onClick={() => setActiveTab(idx)}
            key={tab.title}
          >
            {tab.title}
          </div>
        ))}
      </div>
    </div>
  );
};
